import { forwardRef } from 'react';
import { cx } from './cx';

export interface IconButtonProps
  extends Omit<React.ComponentPropsWithoutRef<'button'>, 'aria-label'> {
  'aria-label': string;
  variant?: 'ghost' | 'solid';
  size?: 'sm' | 'md' | 'lg';
}

const base =
  'inline-flex items-center justify-center rounded-full transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-meradio-primary disabled:opacity-50 disabled:cursor-not-allowed';

const variants = {
  ghost: 'text-current hover:bg-white/10',
  solid: 'bg-white text-meradio-dark shadow-lg hover:scale-105',
};

const sizes = {
  sm: 'w-8 h-8',
  md: 'w-10 h-10',
  lg: 'w-12 h-12',
};

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ variant = 'ghost', size = 'md', type = 'button', className, children, ...rest }, ref) => (
    <button
      ref={ref}
      type={type}
      className={cx(base, variants[variant], sizes[size], className)}
      {...rest}
    >
      {children}
    </button>
  )
);

IconButton.displayName = 'IconButton';

export default IconButton;
